import React, { useState } from 'react';
import styles from '../styles/TitlePage.module.css';
import { useAuthContext } from '../context/AuthContext';
import Login from '../pages/Login';


const TitlePage = () => {

    const {token} = useAuthContext; // Récupération du token

    const [isConnexionPageOpen, setIsConnexionPageOpen] = useState(false);
    const [isConnexionPageClosing, setIsConnexionPageClosing] = useState(false);

    if (token) {
        console.log('Token disponible :', token);
        window.location.href = '/dashboard'; // Redirige l'utilisateur connecté vers le dashboard
    } else {
        console.log('Token non disponible');
    }

        // Gestion de la fermeture de PokePage avec animation
        const handleCloseConnexionPage = () => {
            // Active l'état de fermeture qui déclenche l'animation CSS
            setIsConnexionPageClosing(true);
            // Attend la fin de l'animation (300ms) avant de réellement fermer la page
            setTimeout(() => {
                setIsConnexionPageOpen(false);
                setIsConnexionPageClosing(false);
            }, 300); // Durée qui correspond à la transition CSS dans Dashboard.module.css
        };



    return (
        <div>
            <div className={styles.container}>
                <img className={styles.splash_art} src='/assets/title_screen/splash_art.png' alt="" />
                <img className={styles.logo} src='/assets/logo/poketask.png' alt="" />
                <div className={`${styles.connexion_button} ${(isConnexionPageOpen) ? styles.invisible_button : ''}`} onClick={() => setIsConnexionPageOpen(true)}>
                    <div>
                        <p>Bienvenue !</p>
                    </div>
                </div>
                {/* <button onClick={handleSubmit}>Se connecter</button> */}
                <div className={`${styles.contentPage} 
                ${/* Ajoute la classe visible si une des pages est ouverte */
                (isConnexionPageOpen || isConnexionPageOpen) ? styles.visible : ''} 
                ${/* Ajoute la classe invisible pendant l'animation de sortie */
                (isConnexionPageClosing || isConnexionPageClosing) ? styles.invisible : ''}`}>
                {/* Rendu conditionnel des pages */}
                {isConnexionPageOpen && (
                    <Login onClose={handleCloseConnexionPage}/>
                )}
                </div>
            </div>
            
        </div>
    );
};

export default TitlePage;